import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  Typography,
  Divider,
  Button,
  Box
} from "@mui/material";

const OrderPlacedModal = ({ open, onClose, orderDetails }) => {


    const handleCloseModal=()=>{
        onClose()
    }
  return (
    <Dialog open={open}  maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
        🎉 Order Placed Successfully
      </DialogTitle>
      <DialogContent dividers>
        {orderDetails && Array.isArray(orderDetails) ? (
          orderDetails.map((order, index) => (
            <Box key={index} mb={4}>
              <Typography variant="subtitle1" fontWeight="bold">
                Order ID: {order.orderId}
              </Typography>

              <Typography mt={2} fontWeight="bold">
                Items:
              </Typography>
              <List>
                {order.items.map((item, idx) => (
                  <React.Fragment key={idx}>
                    <ListItem alignItems="flex-start" sx={{ display: "block" }}>
                      <Typography variant="body1" fontWeight="medium">
                        {item.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Quantity: {item.quantity}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Price: ₹{item.price}
                      </Typography>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                ))}
              </List>
            </Box>
          ))
        ) : (
          <Typography>No orders found.</Typography>
        )}

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => onClose(true)}
          sx={{ mt: 2 }}

        >
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default OrderPlacedModal;
